// extracted by mini-css-extract-plugin
export default {"content":"styles_content__m-1j0","loader":"styles_loader__QCg2N"};